import { supabase } from '../lib/supabase'
import { v4 as uuidv4 } from 'uuid';
import {db} from '../db';

import { errorMessage } from '../utils/errors';
import { syncvalue, dateFromStorage, dateToStorage, timeFromStorage, timeToStorage } from "../utils/datetime";
import { syncRecordsets, handleRemoteDeletions } from '../utils/sync';

const template = () => {
    const record = {
        id: null,
        user_id: null,
        facility_id: null,
        animal_id: null,
        started_on: true,
        submitted_on: true,
        confirm_section_a_incomplete: false,
        confirm_section_b_incomplete: false,
        confirm_section_c_incomplete: false,
        confirm_section_cioa_incomplete: false,
        no_incidents_of_aggression:false,
        assessment_title: null,
        is_visibile_in_reports: true,
        start_of_day: null,
        end_of_day: null,
        assessment_type_id: null,
        section_a_timer_seconds: null,
        section_b_timer_seconds: null,
        report_path: null,
        report_title: null,
        report_range: null,
    };

    return {...record};
}


const transformFromDb = (inputRecord) => {
    const temp = {...inputRecord};
    temp['is_visibile_in_reports'] = temp['is_visibile_in_reports'] !== false;
    temp['started_on'] = dateFromStorage(temp['started_on']);
    temp['submitted_on'] = dateFromStorage(temp['submitted_on']);
    temp['start_of_day'] = timeFromStorage(temp['start_of_day']);
    temp['end_of_day'] = timeFromStorage(temp['end_of_day']);
    /*
    temp['report_path'] = temp['report_path'] || "";
    temp['report_title'] = temp['report_title'] || "";
    temp['report_range'] = temp['report_range'] || "";
    */
    return temp;
}

const transformToDb = (inputRecord) => {
    const temp = {...inputRecord};
    temp['is_visibile_in_reports'] = temp['is_visibile_in_reports'] !== false;
    temp['started_on'] = dateToStorage(temp['started_on']);
    temp['submitted_on'] = dateToStorage(temp['submitted_on']);
    temp['start_of_day'] = timeToStorage(temp['start_of_day']);
    temp['end_of_day'] = timeToStorage(temp['end_of_day']);
    // we don't want these three fields to be populated from the client at all, just read from the server
    delete temp['report_path'];
    delete temp['report_title'];
    delete temp['report_range'];
    return {assessment: temp};
}

const toDexie = (inputRecord) => {
    const temp = {...inputRecord};
    temp['is_visibile_in_reports'] = temp['is_visibile_in_reports'] !== false;
    temp['started_on'] = dateToStorage(temp['started_on']);
    temp['submitted_on'] = dateToStorage(temp['submitted_on'])||null;
    temp['start_of_day'] = timeToStorage(temp['start_of_day']);
    temp['end_of_day'] = timeToStorage(temp['end_of_day']);
    return temp;
}

const fromDexie = (inputRecord) => {
    const temp = {...inputRecord};
    temp['is_visibile_in_reports'] = temp['is_visibile_in_reports'] !== false;
    temp['started_on'] = dateFromStorage(temp['started_on']);
    temp['submitted_on'] = dateFromStorage(temp['submitted_on']);
    temp['start_of_day'] = timeFromStorage(temp['start_of_day']);
    temp['end_of_day'] = timeFromStorage(temp['end_of_day']);
    return temp;
}


const newAssessment = () =>  {
    return template();
};

const listAssessments = async() => {
    try {

        const temp = await db().assessments.toCollection().toArray();
        return temp.map((cur)=>{
            return fromDexie(cur);
        });

    } catch (error) {
        console.error(error);
        throw error;
    }
}

const listAssessmentsBySync = async(lastSync) => {
    try {

        const temp = await db().assessments.where('sync').aboveOrEqual(lastSync).toArray();
        return temp.map((cur)=>{
            return fromDexie(cur);
        });

    } catch (error) {
        console.error(error);
        throw error;
    }
}

const listAssessmentsByAnimal = async(animalId) => {
    try {

        //const temp = await db().assessments.where('animal_id').equals(animalId).sortBy('started_on').reverse().toArray();
        const temp = await db().assessments.where('animal_id').equals(animalId).reverse().sortBy('started_on');
        return temp.map((cur)=>{
            return fromDexie(cur);
        });

    } catch (error) {
        console.error(error);
        throw error;
    }
}

/*
const listAssessmentsByOpenStatus = async() => {
    try {

        //const temp = await db().assessments.where('animal_id').equals(animalId).sortBy('started_on').reverse().toArray();
        const temp = await db().assessments.where('submitted_on').notEqual("").reverse().sortBy('started_on');
        return temp.map((cur)=>{
            return fromDexie(cur);
        });

    } catch (error) {
        console.error(error);
        throw error;
    }
}
*/

const fetchAssessments = async() => {
    try {
        const fetchResults = await supabase
            .from('assessments')
            .select('*')
        console.log(fetchResults);
        if (fetchResults.error) throw new Error(`Error ${fetchResults.error.code}: ${fetchResults.error.message}`);
        if (fetchResults.data !== null) {
            return fetchResults.data.map((cur)=>{
                return transformFromDb(cur);
            });
        }
  } catch (error) {
        console.error(error);
        throw error
  }
}

const fetchAssessmentsBySync = async(lastSync) => {
    try {
        const fetchResults = await supabase
            .from('assessments')
            .select('*')
            .gte('sync',lastSync)
        console.log(fetchResults);
        if (fetchResults.error) throw new Error(`Error ${fetchResults.error.code}: ${fetchResults.error.message}`);
        if (fetchResults.data !== null) {
            return fetchResults.data.map((cur)=>{
                return transformFromDb(cur);
            });
        }
  } catch (error) {
        console.error(error);
        throw error
  }
}

const getAssessment = async(id) => {
    try {

        const temp = await db().assessments.where('id').equals(id).first();
        console.log(temp);
        return fromDexie(temp);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const fetchAssessment = async(id) => {

    try {
        const fetchResults = await supabase
            .from('assessments')
            .select('*')
            .eq('id', id);
        console.log(fetchResults);
        if (fetchResults.error) throw new Error(`Error ${fetchResults.error.code}: ${fetchResults.error.message}`);
        if (fetchResults.data !== null) {
            return transformFromDb(fetchResults.data[0]);
        }
  } catch (error) {
        console.error(error);
        throw error
  }
}


const fetchAssessmentExportDataByAnimalId = async(animalId,previousAssessmentCount) => {
    try {

        previousAssessmentCount = previousAssessmentCount || 4;

        const fetchResults = await supabase
            .from('assessments')
            .select('*, assessment_final_evaluations(*), section_a(*), section_b(*, section_b_behaviors(*)), section_c(*), section_c_incidents_of_aggression(*)')
            .eq('animal_id', animalId);

        console.log(fetchResults);
        if (fetchResults.error) throw new Error(`Error ${fetchResults.error.code}: ${fetchResults.error.message}`);
        return fetchResults.data;

        /*
        if (fetchResults.data !== null) {
            return transformFromDb(fetchResults.data[0]);
        }
        */

  } catch (error) {
        console.error(error);
        throw error
  }
}


const writeAssessmentToDexie = async(inputRecord) => {
    try {
        const cleanRecord = toDexie(inputRecord);
        const id = await db().assessments.put(cleanRecord)
        console.log('wrote id: ', id);
        return id;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const writeAssessmentToSupabase = async(inputRecord, facilityId) => {
    try {

        inputRecord.facility_id = inputRecord.facility_id || facilityId;

        const {assessment} = transformToDb(inputRecord);

        const assessmentResult = await supabase.from("assessments").upsert(assessment);
        console.log("assessmentResult: ", assessmentResult);
        if (assessmentResult.error) throw new Error(errorMessage(assessmentResult.error));
        return {assessmentResult, id: assessment.id};


    } catch (error) {
        console.error(error);
        throw error;
    }
}

const dexieDeleteAssessment = async(assessmentId) => {
    try {
        const database = db();

        return await database.transaction(
            'rw',
            database.assessments,
            database.sectiona,
            database.sectionb,
            database.sectionc,
            database.sectioncioa,
            database.finalevaluations,
            async () => {
                const [
                    sectionAIds,
                    sectionBIds,
                    sectionCIds,
                    sectionCIoAIds,
                    finalEvaluationIds,
                ] = await Promise.all([
                    database.sectiona.where('assessment_id').equals(assessmentId).primaryKeys(),
                    database.sectionb.where('assessment_id').equals(assessmentId).primaryKeys(),
                    database.sectionc.where('assessment_id').equals(assessmentId).primaryKeys(),
                    database.sectioncioa.where('assessment_id').equals(assessmentId).primaryKeys(),
                    database.finalevaluations.where('id').equals(assessmentId).primaryKeys(),
                ]);

                if (sectionAIds.length > 0) await database.sectiona.bulkDelete(sectionAIds);
                if (sectionBIds.length > 0) await database.sectionb.bulkDelete(sectionBIds);
                if (sectionCIds.length > 0) await database.sectionc.bulkDelete(sectionCIds);
                if (sectionCIoAIds.length > 0) await database.sectioncioa.bulkDelete(sectionCIoAIds);
                if (finalEvaluationIds.length > 0) await database.finalevaluations.bulkDelete(finalEvaluationIds);

                await database.assessments.delete(assessmentId);

                return {
                    assessmentId,
                    deleted: {
                        sectiona: sectionAIds.length,
                        sectionb: sectionBIds.length,
                        sectionc: sectionCIds.length,
                        sectioncioa: sectionCIoAIds.length,
                        finalevaluations: finalEvaluationIds.length,
                        assessments: 1,
                    },
                };
            }
        );
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const supabaseDeleteAssessment = async(assessmentId) => {
    try {
        const deleteResult = await supabase.from("assessments").delete().eq('id', assessmentId);
        if (deleteResult.error) throw new Error(errorMessage(deleteResult.error));
        return deleteResult;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const deleteAssessment = async(assessmentId, isOnline) => {
    try {
        if (!assessmentId) throw new Error("assessmentId is required");
        if (!isOnline) throw new Error("Assessment deletion requires an online connection");

        const supabaseResults = await supabaseDeleteAssessment(assessmentId);
        const dexieResults = await dexieDeleteAssessment(assessmentId);

        return {supabaseResults, dexieResults, id: assessmentId};
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const saveAssessment = async(inputRecord, facilityId, userId, isOnline) => {

    const syncValue = syncvalue();

    inputRecord.id = inputRecord.id || uuidv4();
    inputRecord.facility_id = inputRecord.facility_id || facilityId;
    inputRecord.user_id = inputRecord.user_id || userId;
    inputRecord.is_visibile_in_reports = inputRecord.is_visibile_in_reports !== false;
    inputRecord.sync = syncValue;

    const dexieResults = await writeAssessmentToDexie(inputRecord);
    const supabaseResults = (isOnline) ? await writeAssessmentToSupabase(inputRecord,facilityId) : {status: "offline"};
    return {dexieResults, supabaseResults, id: inputRecord.id};
}

const sync = async({facilityId, lastSync = null}) => {

    const deletedRecords = await handleRemoteDeletions({tableName: "assessments", listFunc: listAssessments, supabase, dbTable: db().assessments});
    console.log("deletedRecords", deletedRecords);

    const {remoteData, localData} = (lastSync) ? await syncPartialRecordSets(lastSync) : await syncFullRecordSets();
    const results = await syncRecordsets({
        remoteData,
        localData, 
        remoteWriteFunc: writeAssessmentToSupabase, 
        localWriteFunc: writeAssessmentToDexie, 
        remoteWriteFuncArgs: [facilityId]});
    return results;
}

const syncFullRecordSets = async (facilityId) => {
    const remoteData = await fetchAssessments() || [];
    const localData = await listAssessments() || [];

    return {remoteData, localData};
};

const syncPartialRecordSets = async (lastSync) => {

    const remoteData = await fetchAssessmentsBySync(lastSync) || [];
    const localData = await listAssessmentsBySync(lastSync) || [];

    return {remoteData, localData};
};


const truncateDexie = async() => {
    return await db().assessments.clear();
}


const noIncidentsOfAggression = async(assessmentId, isOnline) => {
    try {
        const record = {no_incidents_of_aggression:true}
        const result = await db().assessments.where('id').equals(assessmentId).modify(record);

        let supabaseStatus = undefined;
        if (isOnline) {
            const updateResult = await supabase.from("assessments").update(record).eq('id',assessmentId);
            console.log('update',updateResult);
            if (updateResult.error) throw new Error(errorMessage(updateResult.error));

            supabaseStatus = updateResult.data;

        } else {
            supabaseStatus = {status: 'offline'};
        }

        return {dexie: result, supabase: supabaseStatus};
    } catch (error) {
        throw error;
    }
}

export {newAssessment, listAssessments, listAssessmentsByAnimal, getAssessment, fetchAssessments, fetchAssessment, fetchAssessmentExportDataByAnimalId, saveAssessment, deleteAssessment, sync, truncateDexie,noIncidentsOfAggression};
